type TMainTitleProps = {
  children: React.ReactNode;
  size?: 'sm' | 'md' | 'lg';
} & React.HTMLAttributes<HTMLHRElement>;

export default function SectionTitle({
  children,
  size = 'md',
  ...props
}: TMainTitleProps) {
  return (
    <h2 {...props} className={`${props.className ?? ''}`}>
      {children}
    </h2>
  );
}
